import {Injectable} from '@angular/core';

declare const Notyf: any;

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private notyf = new Notyf({
    duration: 5500,
    position: {
      x: 'center',
      y: 'bottom',
    }
  });

  /** The last toast shown, so the same one is not stacked twice (see `isRepeat`). */
  private last = {type: '', message: '', at: 0};

  constructor() {
  }

  success(message: string) {
    if (!this.isRepeat('success', message)) {
      this.notyf.success(message);
    }
  }

  error(message: string) {
    if (!this.isRepeat('error', message)) {
      this.notyf.error(message);
    }
  }

  /**
   * True for the same toast again within 2 seconds: a Save pressed twice gets one answer (the
   * IdempotencyInterceptor shares it), and so one "Saved".
   */
  private isRepeat(type: string, message: string): boolean {
    const now = Date.now();
    const repeat = this.last.type === type && this.last.message === message && now - this.last.at < 2000;
    this.last = {type, message, at: now};
    return repeat;
  }
}
